import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useEnterpriseDriverCreate = () => {
  const { mutateAsync, status } = useMutation({
    mutationFn: repo.createEnterpriseDriver,
  });

  return {
    createEnterpriseDriverMutateAsync: mutateAsync,
    createEnterpriseDriverStatus: status,
  };
};
